<template>
    <div>
        <p class="display-4">Teleatendimento</p>
        <hr>
        <az-video-call />
    </div>
</template>

<script>
import AzVideoCall from '../shared/zoom/AzVideoCall.vue';
export default {
    components: { 
        AzVideoCall, 
    }
}
</script>